import gql from 'graphql-tag'

export const LOAD_PAGE = gql`
    query loadPage($pageID: ID!) {
        loadPage(pageID: $pageID) {
            id
            parentPageIdentifier
            sortIndex
            deactivated
            isTemplate
            isStartPage
            createdAt
            updatedAt
            deletedAt
            currentVersion {
                id
                pageID
                state
                contents
                createdAt
                updatedAt
                pageSettings {
                    htmlTitle
                    urlTitle
                    metaDescription
                    metaKeywords
                    robotsOption
                    includeInSitemapXML
                    pageRank
                    changeFrequency
                    language
                    translationID
                }
                updatedBy {
                    id
                    name
                }
            }
        }
    }
`
